import React from "react";
import styles from "./RSVPCelebrate.module.css";
import flowerImg from "../../../../../assets/rsvpFlower.png";
import { SubmitButton, TextComponent } from "../../../../../components";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../../Store/Middlewares/EventPlanningMiddleware";
const RSVPCelebrate = () => {
  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const RSVP = useSelector((state) => state.EventPlanningReducer.RSVP);
  const navigate = useNavigate(); 
  return (
    <div className={styles.mainCont}>
      {RSVP?.invite_type == "message" ? (
        <>
          <div className={styles.imgdiv}>
            <img src={flowerImg} />
          </div>
          <TextComponent text={RSVP?.tagline} textClass={styles.heading} />
          <div className={styles.description}>
            <TextComponent text={RSVP?.message} />
          </div>
        </>
      ) : (
        <div className={styles.tempCont}>
          <img src={RSVP?.template_image} alt="" />
        </div>
      )}
      <TextComponent
        text={`${EventDetails?.groom?.first_name} & ${EventDetails?.bride?.first_name}`}
        textClass={styles.heading2}
      />
      <TextComponent text={EventDetails?.name} textClass={styles.title} />
      <div className={styles.btnDiv}>
        <SubmitButton
          title="Next"
          btnClass={styles.btn}
          onClick={() => navigate("/events/RSVPSend",{state:{headrTitle:"RSVP"}})}
        />
      </div>
    </div>
  );
};

export default RSVPCelebrate;
